import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import About from "./pages/About";
import Team from "./pages/Team";
import Blogs from "./pages/Blogs";
import Contact from "./pages/Contact";
import MachineGallery from "./pages/Machines";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import "@fortawesome/fontawesome-free/css/all.min.css";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ProjectDetails from "./pages/ProductDetails";
import MainBranch from "./pages/MainBranch";
import SubBranch from "./pages/SubBranch";
import FounderDetails from "./components/about/FounderDetails";
import ScrollToTop from "./components/about/ScrollToTop";
import FounderSection from "./components/about/FounderSection";

function Layout() {
  const location = useLocation();

  return (
    <>
      {/* Hide Navbar on Home */}
      {location.pathname !== "/" && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/machines" element={<MachineGallery/>}/>
        <Route path="/blog/:id" element={<BlogDetailsPage />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/products" element={<ProjectDetails />} />
 <Route path="/units/main" element={<MainBranch />} />
 <Route path="/units/sub" element={<SubBranch />} />
 <Route path="/" element={<MainBranch />} />
        <Route path="/project-details" element={<ProjectDetails />} />
  <Route path="/" element={<FounderSection />} />
<Route path="/founder" element={<FounderDetails />} />
      


      </Routes>

      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
